import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'entering:animate-in entering:fade-in exiting:animate-out exiting:fade-out z-50 max-h-60 w-60 overflow-auto bg-white p-[30px] shadow-[0_0_12px_0_rgba(55,35,9,0.12)]',
    listbox: 'flex flex-col gap-[26px] outline-hidden',
    option:
      'text-bg-main-inversion flex cursor-default items-center justify-center text-base font-light select-none hover:cursor-pointer hover:bg-transparent focus:bg-transparent data-[focused=true]:bg-transparent data-[hovered=true]:bg-transparent'
  },
  variants: {
    hide: {
      true: {
        option: 'hidden'
      }
    },
    isEmpty: {
      true: {
        base: 'hidden'
      }
    },
    theme: {
      default: {
        option: 'hover:text-brand-primary'
      },
      predator: {
        option: 'hover:text-brand-predator'
      }
    }
  },
  defaultVariants: {
    theme: 'default'
  }
});
